import axios from '@/components/api/axios';

async function getNote() {
  const res = await axios.axiosGet('/api/fanClub/notes/getNote', null);
  return res;
}



export default {
  getNote
}



// WEBPACK FOOTER //
// ./src/components/api/fanClub/notes.js